<div class="card panel-monsido-card max-height stats-summary-traffic-sources-panel d-flex flex-column">
    <div class="card-header">
        <h2 class="font-weight-300">
            Traffic sources
        </h2>
    </div>
    <div class="card-body flex-grow-1">
        <mon-spinner [loading]="loading">
            <mon-chart-bar [height]="150"
                       [data]="lineChartData"
                       [labels]="lineChartLabels"
                       [series]="lineChartSeries"
                       [colors]="lineChartColors"
                       [override]="lineChartOverride"
                       [options]="chart.options">
            </mon-chart-bar>

            <div class="row mt-5 mb-1">
                <div class="col-18 offset-2">
                    <div class="position-relative">
                        <span class="vertical-ruler vertical-ruler-left ruler-primary"></span>
                        <notification class="block pl-3" title="{{'Search Engines' | translate }}" [digit]="counts.organic">
                        </notification>
                    </div>
                </div>
                <div class="col-26">
                    <statistics-distribution [visits]="counts.organic" [totalVisits]="counts.total"></statistics-distribution>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-18 offset-2">
                    <div class="position-relative">
                        <span class="vertical-ruler vertical-ruler-left ruler-success"></span>
                        <notification  class="block pl-3" title="{{'Direct visits' | translate }}" [digit]="counts.direct">
                        </notification>
                    </div>
                </div>
                <div class="col-26">
                    <statistics-distribution [visits]="counts.direct" [totalVisits]="counts.total"></statistics-distribution>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-18 offset-2">
                    <div class="position-relative">
                        <span class="vertical-ruler vertical-ruler-left ruler-warning"></span>
                        <notification  class="block pl-3" title="{{'Referring visits' | translate }}" [digit]="counts.referring">
                        </notification>
                    </div>
                </div>
                <div class="col-26">
                    <statistics-distribution [visits]="counts.referring" [totalVisits]="counts.total"></statistics-distribution>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-18 offset-2">
                    <div class="position-relative">
                        <span class="vertical-ruler vertical-ruler-left ruler-info"></span>
                        <notification  class="block pl-3" title="{{'Social visits' | translate }}" [digit]="counts.social">
                        </notification>
                    </div>
                </div>
                <div class="col-26">
                    <statistics-distribution [visits]="counts.social" [totalVisits]="counts.total"></statistics-distribution>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-18 offset-2">
                    <div class="position-relative">
                        <span class="vertical-ruler vertical-ruler-left ruler-danger"></span>
                        <notification  class="block pl-3" title="{{'Campaign visits' | translate }}" [digit]="counts.paid">
                        </notification>
                    </div>
                </div>
                <div class="col-26">
                    <statistics-distribution [visits]="counts.paid" [totalVisits]="counts.total"></statistics-distribution>
                </div>
            </div>
        </mon-spinner>
    </div>
    <div class="card-footer bg-white text-right">
        <a data-test="summary-link-traffic-sources" uiSref="base.customer.domain.statistics.sources.summary" class="text-uppercase" [attr.aria-label]="'Go to traffic sources overview' | translate">
            <span translate>Traffic sources</span>
            <span class="fas fa-angle-right ml-1" aria-hidden="true"></span>
        </a>
    </div>
</div>
